/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminFooter from "components/Footers/AdminFooter.js";

import routes from "routes.js";
import { useAuth } from "context/AuthProvider";
import Header from "components/Headers/Header";
import SidebarUser from "components/Sidebar/SidebarUser";
import UserNavbar from "components/Navbars/UserNavbar";
const UserLayout = (props) => {

 

  const mainContent = React.useRef(null);
  const location = useLocation();
  React.useEffect(() => {
   // Verificar si mainContent.current es null antes de intentar acceder a sus propiedades
   if (mainContent.current) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }
  }, [location]);

  const { hasLoginEmpleado } = useAuth();
  if (!hasLoginEmpleado) {
    return <Navigate to={"/auth/login/empleado"} />;
  }
  const normalizeRoutePath = (path) => path.replace(/^\//, "");
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if ( prop.layout.startsWith("/user")) {
        return (
          <Route path={normalizeRoutePath(prop.path)} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
 
  return (
    <>
  
      <SidebarUser
        {...props}
        routes={routes}
        logo={{
          innerLink: "/user/index",
          imgSrc: require("../assets/img/brand/logo.png"),
          imgAlt: "...",
        }}
      />
      <div className="main-content " ref={mainContent} >
        <UserNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Header/>
        <Container className="mt--7" fluid>
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to={"/user/index"} replace />} />
        </Routes>
        </Container>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default UserLayout;

